<script>
export default {
  methods: {
    /**
     * @param {string} documentId
     * @param {?string} [view]
     * @param {string} [hash='']
     * @returns {Object}
     */
    makeDocumentRoute(documentId, view = null, hash = '') {
      return {
        name: 'document',
        params: {
          id: documentId,
          view: view
        },
        hash: hash
      };
    },

    /**
     * @param {string} documentId
     * @param {string} [hash='']
     * @returns {Object}
     */
    makeDocumentCardRoute(documentId, hash = '') {
      return this.makeDocumentRoute(documentId, 'card', hash);
    },

    /**
     * @param {string} documentId
     * @param {?string} [anchorId]
     * @returns {Object}
     */
    makeDocumentHtmlRoute(documentId, anchorId = null) {
      let hash = anchorId !== null ? `#${anchorId}` : '';

      return this.makeDocumentRoute(documentId, 'html', hash);
    },

    /**
     * @param {string} documentId
     * @param {?number} [pageIndex]
     * @returns {Object}
     */
    makeDocumentScanRoute(documentId, pageIndex = null) {
      let hash = pageIndex !== null ? `##${pageIndex}` : '';

      return this.makeDocumentRoute(documentId, 'scan', hash);
    }
  }
};
</script>
